/* @flow */

import * as React from 'react';

import {colors} from '../colors';
import {LoadingIcon} from '../icon';

type Props = {
    size?: number,
    padding?: number,
    fill?: string,
};

export function LoadingPage(props: Props) {
    const {fill = colors.orangeLt} = props;

    return (
        <div
            style={{padding: typeof props.padding === 'number' ? `${props.padding}px` : '24px'}}
            className='full-height full-width flex align-center justify-center border-box'
        >
            <LoadingIcon size={props.size} fill={fill} />
        </div>
    );
}
